import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form } from "antd";
import { setInputMode } from "../../services/input";
import { AnnotatedFormItem } from "./AnnotatedFormItem";

export const Email2FormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <AnnotatedFormItem label="パートナー様メールアドレス" annotation="任意">
      <Input
        ref={setInputMode("email")}
        type="email"
        value={store.email2}
        onChange={e => {
          store.email2 = e.target.value;
        }}
      />
    </AnnotatedFormItem>
  );
});
